<script>
import { authApi } from 'api'
export default {
  render (h) {
    return h()
  },
  beforeCreate () {
    if (this.$route.query.jwt) {
      const bookId = this.$route.query.bookId
      const jwtRedirect = this.$route.query.redirect
      authApi.getTokenWithBookId(bookId, this.$route.query.jwt)
        .then(token => {
          // TODO: ta vare på info om at login kom via jwt fra skolen, lage ny funksjonalitet i store som tar vare på dette
          this.$store.dispatch('setLoginOrigin', 'jwt')
          this.$router.replace('/login?token=' + token + '&bookId=' + bookId + '&redirect=' + jwtRedirect)
        })
        .catch(this.$router.replace('/loading'))
      return // må returnere ellers fortsetter koden mens promise resolves
    }

    if (!this.$route.query.token) {
      authApi.ssoLoginUrl(this.$route.query.bookId, this.$route.query.redirect).then(redirect => { window.location = redirect })
      return
    }

    this.$store.dispatch('setToken', this.$route.query.token)
    this.$router.replace(this.$route.query.redirect !== undefined ? this.$route.query.redirect : '/book/' + this.$route.query.bookId)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/Login.vue